<template>
  <SecondaryVaccinationPage
    title="50 years and above"
    :vaccines="vaccinesList"
    prevRoute="/oldPeoplePage"
    nextRoute="/vaccination"
    :secondaryImage="require('@/assets/page9/Asset 52.png')"
    :footerBanner1="require('@/assets/page9/Asset 56.png')"
    :footerBanner2="require('@/assets/page4/lowererPanner.png')"
  />
</template>

<script setup>
import SecondaryVaccinationPage from "@/components/SecondaryVaccinationPage.vue";

const vaccinesList = [
  {
    imgPath: require("@/assets/page8/Asset 36.png"),
    name: "Influenza",
    ModalData: {
      Indications: {
        text: "All persons ≥6 months",
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: "One dose every year, preferred before the winter season",
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction</br>
        Precautions:  
                Moderate or severe acute illness with or without fever`,
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page8/Asset 37.png"),
    name: "Pneumococcal",
    ModalData: {
      Indications: {
        text: `Recommended for all adults aged 50 years and older, as well as adults aged 19 to 64 who have specific medical conditions or other risk factors for pneumococcal disease.`,
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: `A single dose of PCV20 or PCV13/15 followed by a dose of PPSV23 one year later if immunocompetent or ≥8 weeks if immunocompromised. For patients who have previously received one or more doses of PPSV23 only, a single dose of PCV20 or PCV13/15 should be given ≥1 year after the last PPSV23 dose was received. For those who previously received PCV13 only, a single dose of PCV20 should be given ≥1 year after the last PCV13 dose was received.
`,
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction to this vaccine, including (for PCV13) to any diphtheria toxoid-containing vaccine, or to any of its components </br>
        Precautions:
Moderate or severe acute illness.`,
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page8/Asset 46.png"),
    name: "HepatitisA",
    ModalData: {
      Indications: {
        text: `All adults seeking protection from (HAV) infection and persons with other risk factors.`,
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: "2 doses schedule with a minimum of 6 months interval",
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction <br />
        Precautions :
Moderate or severe acute illness.`,
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page8/Asset 47.png"),
    name: "HepatitisB",
    ModalData: {
      Indications: {
        text: "Recommended if some other risk factor is present (e.g., occupational, lifestyle, or other indications)",
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: `3-doses series at 0, 1 and 6 month intervals.`,
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction <br />
        Precautions:
                          Moderate or severe acute illness with or without fever`,
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page8/Asset 38.png"),
    name: "RSV",
    ModalData: {
      Indications: {
        text: "Adults ≥60 years (IM)",
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: "A single dose administered via the intramuscular (IM) route.",
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: `History of severe allergic reaction, such as anaphylaxis, to any component of the vaccine. </br>
Precautions: </br>
Moderate or severe acute illness with or without fever.
`,
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page8/Asset 39.png"),
    name: "Zoster",
    ModalData: {
      Indications: {
        text: "Shingrix (RZV) for adults ≥50 years (IM)",
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: "2 doses - Shingrix (RZV) 2nd dose, 2-6 months apart.",
        img: require("@/assets/page9/Asset 54.png"),
      },
      /* eslint-disable */
      Contraindications: {
        text: `History of severe allergic reaction, such as anaphylaxis, to any component of the vaccine. </br>
Precautions:</br>
Moderate or severe acute illness with or without fever.
`,
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page8/Asset 40.png"),
    name: "OldPeople",
    ModalData: {
      Indications: {
        text: "No data",
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: "No data",
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: "No data",
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page8/Asset 41.png"),
    name: "COVID-19",
    ModalData: {
      Indications: {
        text: `Individuals 12 years and above regardless of previous vaccination. A priority to people with any of the following conditions: </br>
          Age over 50 years </br>
          Pregnant women </br>
          Chronic heart, lung, kidney, neurological diseases </br>
          Hereditary blood disorders (sickle cell anemia, thalassemia) </br>
          Immunocompromised conditions</br>
          Travelers for Umrah and Hajj</br>
          Healthcare workers with direct patient contact</br>
          `,
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: `1 dose intramuscular, 3 months after the most recent dose.`,
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: `History of a severe allergic reaction after a previous dose or to a component of the COVID-19 vaccine. </br >
        <strong>  Precautions: </strong> </br>
        
          Moderate or severe acute illness, with or without fever.</br>
          History of a non-severe, immediate (onset less than 4 hours) allergic reaction after administration of a previous dose of one COVID-19 vaccine type.</br>
          History of myocarditis or pericarditis within 3 weeks after a dose of any COVID-19 vaccine.</br>
`,
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },

  {
    imgPath: require("@/assets/page8/Asset 44.png"),
    name: "Tetanus",
    ModalData: {
      Indications: {
        text: `A single dose of Tdap/Td every 10 years for adult population`,
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: `Single dose intramuscular injection`,
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: `Severe allergic reaction to vaccine components`,
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page8/Asset 42.png"),
    name: "MMR",
    ModalData: {
      Indications: {
        text: "Individuals at higher risk of either exposure or morbidity.",
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: `Adults without evidence of immunity should receive a single dose of the MMR vaccine. High-risk individuals (e.g., healthcare personnel, international travelers) who are susceptible should receive 2 doses, administered 4 weeks apart.`,
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction, pregnancy, immunocompromising conditions.`,
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page8/Asset 43.png"),
    name: "Varicella",
    ModalData: {
      Indications: {
        text: "All adults without evidence of immunity to varicella.",
        img: require("@/assets/page9/Asset 53.png"),
      },
      Administration: {
        text: "2 doses, 2nd dose is given 4—8wks after the 1st dose.",
        img: require("@/assets/page9/Asset 54.png"),
      },
      Contraindications: {
        text: "Previous severe allergic reaction, pregnancy, immunosuppression.",
        img: require("@/assets/page9/Asset 55.png"),
      },
    },
  },
];
</script>
